import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconFacebook: React.FC<IconProps> = ({ width = 25, height = 25, color = '#000' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 33 32"
            fill="none"
        >
            <path
                d="M32.0288 16.5515C32.0288 24.3568 26.3101 30.8262 18.8347 31.999V21.0717H22.4784L23.1717 16.5515H18.8347V13.6183C18.8347 12.3813 19.4407 11.1761 21.3831 11.1761H23.3549V7.32786C23.3549 7.32786 21.5652 7.02244 19.8542 7.02244C16.2826 7.02244 13.948 9.18725 13.948 13.1064V16.5515H9.97756V21.0717H13.948V31.999C6.47257 30.8262 0.753906 24.3568 0.753906 16.5515C0.753906 7.91549 7.75533 0.914062 16.3914 0.914062C25.0274 0.914062 32.0288 7.91549 32.0288 16.5515Z"
                fill={color}
            />
        </svg>
    );
};

export default IconFacebook;
